module.exports = __webpack_public_path__ + "vue-assets/img/coupon.63fb1431.png";